import { humanizeString } from '@chillibean/component-library';
import { useSelector } from 'react-redux';

export const DisplayNameType = {
  STUDY_EVENT: 'studyEventDisplayName',
  STUDY_PROCEDURE: 'studyProcedureDisplayName',
};

export const DefaultDisplayName = {
  [DisplayNameType.STUDY_EVENT]: {
    plural: 'study events',
    singular: 'study event',
  },
  [DisplayNameType.STUDY_PROCEDURE]: {
    plural: 'study procedures',
    singular: 'study procedure',
  },
};

export function useDisplayName() {
  // HOOKS
  // Store
  const { data: protocol } = useSelector((state) => state.protocolReducer.protocol);

  const getDisplayName = (type) => {
    let displayName = DefaultDisplayName[type];

    if (protocol?.[type]) {
      displayName = protocol[type];
    }

    return {
      humanized: {
        plural: humanizeString(displayName.plural),
        singular: humanizeString(displayName.singular),
      },
      original: displayName,
    };
  };

  return { getDisplayName };
}

export default useDisplayName;
